/* eslint-disable */
<template>
  <div>
    <div class="container-fluid no-padding">
      <div class="row bg-primary-dark pos-fixed pos-fixed-1">
        <div class="col-md-3 mb-2 mt-2">
          <input class="form-control block btn-more-radius" @keyup.enter="getOperasyonKayitlari()"
            v-model="searchFilter" type="text" placeholder="Arama yapın...">
        </div>
        <div class="col-md-3 mb-2 mt-2">
          <select @change="listModeChange()" v-model="listingMode" class="form-control btn-more-radius float-left" id="exampleFormControlSelect1">
            <option value="" selected>Tüm İşlemleri Göster</option>
            <option value="MONTAJ (Tam Set)">MONTAJ (Tam Set) İşlemleri Göster</option>
            <option value="MONTAJ (Cihaz)">MONTAJ (Cihaz) İşlemleri Göster</option>
            <option value="DEMONTAJ (Tam Set)">DEMONTAJ (Tam Set) İşlemleri Göster</option>
            <option value="DEMONTAJ (Cihaz)">DEMONTAJ (Cihaz) İşlemleri Göster</option>
            <option value="DEĞİŞİM">CİHAZ DEĞİŞİMİ İşlemleri Göster</option>
            <option value="SERVİS HİZMETİ">SERVİS HİZMETİ İşlemleri Göster</option>
          </select>
          <small class="form-text text-muted">Yapılan işlemin türü</small>
        </div>
        <div class="col-md-3 mb-2 mt-2">
          <select @change="invoiceModeChange()" v-model="invoiceMode" 
            class="form-control btn-more-radius float-left" id="exampleFormControlSelect1">
            <option value="0" selected>Tüm İşlemleri Göster</option>
            <option value="1">Lenoi faturası kesilmiş olanlar</option>
            <option value="2">Montaj noktası faturası kesilmiş olanlar</option>
            <option value="3">Lenoi faturası bekleyenler</option>
            <option value="4">Montaj noktası faturası bekleyenler</option>
          </select>
          <small class="form-text text-muted">Fatura filtrelemesi</small>
        </div>
        <div class="col-md-3 mb-2 mt-2">
          <router-link to="/saha-operasyon/kayit-ekle" class="btn btn-more-radius btn-success float-right"
            v-if="canInsertSahaOperasyon">Yeni Kayıt Oluştur</router-link>
        </div>
      </div>
      <div class="row header bg-primary-dark align-items-center pos-fixed pos-fixed-2">
        <div class="col-md-1 text-left align-middle">TARİH</div>
        <div class="col-md-2 text-left align-middle">MÜŞTERİ / ARAÇ PLAKASI</div>
        <div class="col-md-2 text-left align-middle">SERİ NO.</div>
        <div class="col-md-2 text-left align-middle">MONTAJ NOK.</div>
        <div class="col-md-2 text-left align-middle">FATURA / TUTAR</div>
        <div class="col-md-1 text-left align-middle">OLUŞTURAN</div>
        <div class="col-md-2 text-left align-middle">KOMUTLAR</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="arizalar-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <div class="row content align-items-center" v-for="(islem, index) in filteredData" v-bind:key="'trow-first-' + islem.OPER_ID">
              <div class="col-md-1 align-middle text-left">{{islem.OPER_DATE_FORMATTED}}</div>
              <div class="col-md-2 align-middle justify-content-between">
                <p class="my-0 text-truncate font-weight-bold">{{islem.VEHICLE_NAME}}</p>
                <small class="text-muted">{{islem.CUSTOMER_TITLE}}</small>
                <small v-if="islem.OPER_CUSTOMER_ID == 557 || islem.OPER_CUSTOMER_ID == 2004 || islem.OPER_CUSTOMER_ID == 294"
                  class="text-muted">- {{islem.GROUP_NAME}}</small>
              </div>
              <div class="col-md-2 align-middle font-weight-bold">
                <p class="my-0 font-weight-bold text-truncate font-weight-bold">{{islem.OPER_DEVICE_ID}}</p>
                <small class="text-muted">{{islem.OPER_TYPE}}</small>
              </div>
              <div class="col-md-2 align-middle justify-content-between">
                <p class="my-0 font-weight-bold text-truncate font-weight-bold">{{islem.OPER_POINT}}</p>
                <small class="text-muted">{{islem.OPER_CITY}}</small>
              </div>
              <div class="col-md-2 align-middle justify-content-between">
                <p v-if="islem.OPER_INVOICE_LENOI" class="my-0 text-primary text-truncate">Lenoi : {{islem.OPER_INVOICE_LENOI}}</p>
                <p v-if="islem.OPER_INVOICE_POINT" class="my-0 text-danger text-truncate">Montaj Nok : {{islem.OPER_INVOICE_POINT}}</p>
                <p v-if="islem.OPER_AMOUNT" class="my-0 text-success text-truncate">Tutar : {{islem.OPER_AMOUNT || 0}} TL</p>
              </div>
              <div class="col-md-1 text-truncate">{{islem.PERSONEL_NAME}}</div>
              <div class="col-md-2 text-center align-middle">
                <div class="btn-group">
                  <button class="btn btn-outline-primary btn-more-radius dropdown-toggle"
                    type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    İşlemler
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <h6 class="dropdown-header">Operasyonel İşlemler</h6>
                    <a :disabled="!canUpdateSahaOperasyon" @click="selectSoKaydi(islem.OPER_ID, index)" aria-expanded="false"
                      class="dropdown-item" role="button" data-toggle="modal" data-target="#soUpdateModal">
                      <i class="far fa-file"></i>&nbsp;&nbsp;Fatura Bilgisi Gir</a>
                    <a :disabled="!canUpdateSahaOperasyon" @click="selectSoKaydi(islem.OPER_ID, index)" aria-expanded="false"
                      class="dropdown-item mb-2" role="button" data-toggle="modal" data-target="#soPriceModal">
                      <i class="fas fa-lira-sign"></i>&nbsp;&nbsp;İşlem Ücreti Gir</a>
                    <h6 class="dropdown-header">Diğer İşlemleri</h6>
                    <router-link v-bind:to="'/saha-operasyon/kayit-guncelle/' + islem.OPER_ID" 
                      :disabled="!canUpdateSahaOperasyon"
                      class="dropdown-item" role="button">
                      <i class="far fa-edit"></i>&nbsp;&nbsp;Düzenle</router-link>
                    <a :disabled="!canDeleteSahaOperasyon" @click="openModalForDelete(index, islem.OPER_ID)"
                      data-toggle="modal" data-target="#soDeleteModal" aria-expanded="false"
                      class="dropdown-item text-danger">
                      <i class="far fa-trash-alt text-danger"></i>&nbsp;&nbsp;&nbsp;Kaydı Sil</a>
                  </div>
                </div>
              </div>
            </div>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canDeleteSahaOperasyon" class="modal fade bd-example-modal-lg" id="soDeleteModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Aşağıda bilgileri yer alan operasyon kaydını silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="so-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Operasyon Kaydı Siliniyor...</p>
                </div>
              </template>
              <div class="container">
                <div class="form-row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-kod">Müşteri Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedKayit.CUSTOMER_TITLE">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-name">Araç Plakası</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedKayit.VEHICLE_NAME">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-devid">Araç Plakası</label>
                    <input type="text" readonly class="form-control" id="malzeme-devid"
                      :value="selectedKayit.OPER_DEVICE_ID">
                  </div>
                </div>
                <hr />
                <div class="form-row">
                  <div class="col-md-4 mb-3">
                    <label for="add-qty">İşlem Geliş Tarihi</label>
                    <input type="text" class="form-control" readonly :value="selectedKayit.OPER_DATE_FORMATTED" id="add-qty">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-fabrika">Montaj Noktası</label>
                    <input type="text" readonly class="form-control" :value="selectedKayit.OPER_POINT" id="malzeme-fabrika">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-fabrika">İşin Yapıldığı Şehir</label>
                    <input type="text" readonly class="form-control" :value="selectedKayit.OPER_CITY" id="malzeme-fabrika">
                  </div>
                </div>
                <hr />
                <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-ume">İşlem Notu</label>
                    <textarea readonly class="form-control" :value="selectedKayit.OPER_NOTE" id="malzeme-ume"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteOperasyonKaydi()" class="btn btn-danger">Arıza Kaydını Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canUpdateSahaOperasyon" class="modal fade bd-example-modal-lg" id="soUpdateModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Fatura bilgisini girin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="so-updating">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Operasyon Kaydı Güncelleniyor...</p>
                </div>
              </template>
              <div class="container">
                <div class="form-row">
                  <div class="col-md-12 mb-4">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" id="is-lenoi-invoice" class="custom-control-input" v-model="isLenoiInvoice">
                      <label class="custom-control-label light-text" for="is-lenoi-invoice">
                        {{isLenoiInvoice ? 'Lenoi faturası eklemek istiyorum' : 'Montaj noktası faturası eklemek istiyorum'}}
                      </label>
                      <small id="is-lenoi-invoice" class="form-text text-muted">
                        Yazdığınız fatura numarası bu alanda yaptığınız seçime göre işlenecektir.
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12">
                    <label for="invoice-number">Fatura numarası</label>
                    <input type="text" id="invoice-number" placeholder="Fatura numarası"
                      v-model="invoiceNumber" class="form-control" />
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setInvoiceNumber()" class="btn btn-danger">Fatura Bilgisini İşle</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canUpdateSahaOperasyon" class="modal fade bd-example-modal-lg" id="soPriceModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">İşlem ücretini girin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="so-updating">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Operasyon Kaydı Güncelleniyor...</p>
                </div>
              </template>
              <div class="container">
                <div class="form-row">
                  <div class="col-md-12">
                    <label for="invoice-number">İşlem ücreti</label>
                    <input type="text" id="invoice-number" placeholder="İşlem ücreti"
                      v-model="invoiceNumber" class="form-control" />
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setOperPrice()" class="btn btn-danger">İşlem Ücretini Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'CihazlarPage',
  components: {
    'datepicker': Datepicker
  },
  data () {
    return {
      listingMode: "",
      invoiceMode: "0",
      invoiceNumber: '',
      isLenoiInvoice: false,
      activeMessages: [],
      viewConversation: false,
      arizaMessageText: null,
      kayitlar: [],
      selectedKayit: {},
      selectedKayitIndex: -1,
      selectedKayitId: -1,
      searchFilter: null,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canInsertSahaOperasyon : function() { return this.$store.getters.userCanInsertSahaOperasyon },
    canUpdateSahaOperasyon : function() { return this.$store.getters.userCanUpdateSahaOperasyon },
    canDeleteSahaOperasyon : function() { return this.$store.getters.userCanDeleteSahaOperasyon },
    canWriteMessage : function() { return this.$store.getters.userCanWriteMessage },
    canReadMessage : function() { return this.$store.getters.userCanReadMessage },
    filteredData: {
      get: function() {
        if(this.invoiceMode == 0)
          return this.kayitlar
        else if(this.invoiceMode == 1)
          return this.kayitlar.filter(m => m.OPER_INVOICE_LENOI.length > 0)
        else if(this.invoiceMode == 2)
          return this.kayitlar.filter(m => m.OPER_INVOICE_POINT.length > 0)
        else if(this.invoiceMode == 3)
          return this.kayitlar.filter(m => m.OPER_INVOICE_LENOI == null || m.OPER_INVOICE_LENOI.length == 0)
        else if(this.invoiceMode == 4)
          return this.kayitlar.filter(m => m.OPER_INVOICE_POINT == null || m.OPER_INVOICE_POINT.length == 0)
      }
    }
  },
  methods: {
    openArizaMesajlari(arizaId, arizaIndex) {
      console.log(this.getPersonelId == 3);
      if(this.selectedArizaId == arizaId && this.viewConversation == true) {
        this.viewConversation = false
        return
      }

      this.selectAriza(arizaId, arizaIndex)
      this.viewConversation = true
      this.getArizaMesajlari()
    },
    openModalForDelete(soIndex, soId) {
      this.selectSoKaydi(soIndex, soId)
    },
    selectSoKaydi(soId, soIndex) {
      this.selectedKayitIndex = soIndex
      this.selectedKayitId = soId
      this.selectedKayit = this.filteredData[soIndex]
    },
    getArizaMesajlari() {
      this.$wait.start('kayitlar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ArizaId = this.selectedArizaId

      axios
      .post('/api/sahaoperasyon/tum-kayitlar', getJson)
      .then(response => {
        this.activeMessages = response.data
        this.$wait.end('kayitlar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('kayitlar-loading')
      })
    },
    getOperasyonKayitlari() {
      this.$wait.start('arizalar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.OperType = this.listingMode
      getJson.SearchFilter = this.searchFilter
      getJson.InvoiceMode = this.invoiceMode

      axios
      .post('/api/sahaoperasyon/tum-kayitlar', getJson)
      .then(response => {
        this.kayitlar = response.data
        this.$wait.end('arizalar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('arizalar-loading')
      })
    },
    deleteOperasyonKaydi() {
      axios
      .post('/api/sahaoperasyon/kayit-sil?SessionId=' + this.getSessionId + "&OperId=" + this.selectedKayitId)
      .then(response => {
        this.$toasted.success('Arıza kaydı silindi !', this.toastOptions) 
        this.getOperasyonKayitlari()    
      })
      .catch(error => {
        this.$toasted.success('Arıza kaydı silinemedi. Hata: ' + error.data.ErrorMessage, this.toastOptions)      
      })

      $("#soDeleteModal").modal('hide')
    },
    listModeChange() {
      this.getOperasyonKayitlari()
    },
    invoiceModeChange() {
      this.getOperasyonKayitlari()
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
    dateFormatter(date) {
      return moment(date).format('L')
    },
    setInvoiceNumber() {
      this.$wait.start('so-updating');
      let setJson = {}
      setJson.SessionId = this.getSessionId
      setJson.OperId = this.selectedKayit.OPER_ID
      setJson.InvoiceNumber = this.invoiceNumber
      setJson.IsLenoi = this.isLenoiInvoice

      axios
      .post('/api/sahaoperasyon/fatura-numarasi-ekle', setJson)
      .then(response => {
        this.$toasted.success('Fatura numarası eklendi', this.toastOptions)
      })
      .catch(error => {
        this.$toasted.success('İşlem başarısız oldu. Durum: ' + error.ErrorMessage, this.toastOptions)
        console.log(error)
      })

      this.$wait.end('so-updating')
      $("#soUpdateModal").modal('hide')
    },
    setOperPrice() {
      this.$wait.start('so-updating');
      let setJson = {}
      setJson.SessionId = this.getSessionId
      setJson.OperId = this.selectedKayit.OPER_ID
      setJson.InvoiceNumber = this.invoiceNumber

      axios
      .post('/api/sahaoperasyon/islem-ucreti-ekle', setJson)
      .then(response => {
        this.$toasted.success('İşlem ücreti eklendi', this.toastOptions)
      })
      .catch(error => {
        this.$toasted.success('İşlem başarısız oldu. Durum: ' + error.ErrorMessage, this.toastOptions)
        console.log(error)
      })

      this.$wait.end('so-updating')
      $("#soPriceModal").modal('hide')
    }
  },
  mounted() {
    moment.locale('tr')
    this.getOperasyonKayitlari()
  }
}
</script>

<style scoped>

  html, body {
     overflow-x: hidden !important;
  }

  .container-fluid {
    margin-top: 100px !important;
  }

  .bg-primary-dark {
    background-color: #F7F7F7;
  }

  .pos-fixed {
    width: 100vw;
    position: fixed;
    z-index: 1;
  }

  .pos-fixed-1 {
    top: 80px;
  }

  .pos-fixed-2 {
    top: 135px;
  }

  .row {
    width: calc(100vw - 70px);
    font-size: .875rem;
    border-top: 1px solid #F0F0F0;
  }

  .row.header {
    border-bottom: 1px solid #F0F0F0;
    font-weight: 700;
  }

  .row.header > div, .row.content > div {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .row.header > div, .row.content div {
    border-right: 1px solid #F0F0F0;
  }

  .row > div:last-child {
    border-right: none;
  }

  .row.content {
    background: #FFF;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn, .row.content .btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover, .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md- {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/SahaOperasyonPage.vue